import { css } from "lit";

export const holloCallSheetStyles = css`
  .hollo-call-sheet {
    z-index: 1000;
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    pointer-events: none;
  }
  .hollo-call-card {
    pointer-events: auto;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: linear-gradient(180deg, #7aa1b0 0%, #2e6a86 65%, #255970 100%);
    display: grid;
    grid-template-rows: 1fr auto;
  }
  .hollo-call-hero {
    place-items: center;
    padding-top: 18px;
    color: #fff;
    text-align: center;
    padding: 1rem;
    position: relative;
  }
  .hollo-avatar-wrap {
    width: 160px;
    height: 160px;
    margin: 10px auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  .hollo-hero-name {
    font-size: 25px;
    font-weight: 700;
    margin: 6px 0 4px;
    line-height: 1.2;
  }
  .hollo-hero-time {
    font-size: 16px;
    opacity: 0.92;
  }
  .hollo-hero-status {
    font-size: 12px;
    opacity: 0.85;
    margin-top: 6px;
  }

  .hollo-control-shelf {
    background: rgba(6, 20, 34, 0.85);
    padding: 10px 14px 14px;
    border-top-left-radius: 22px;
    border-top-right-radius: 22px;
  }
  .hollo-shelf-handle {
    width: 36px;
    height: 4px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.75);
    margin: 6px auto 12px;
  }
  .hollo-controls {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    justify-items: center;
    align-items: start;
    padding: 4px;
  }
  .hollo-control {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #fff;
    display: grid;
    gap: 6px;
    justify-items: center;
  }
  .hollo-control-icon {
    width: 56px;
    height: 56px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.18);
  }
  .hollo-control-label {
    font-size: 11px;
    opacity: 0.9;
  }
  .hollo-control.hollo-danger .hollo-control-icon {
    background: #ef4444;
    border: none;
  }

  .hollo-hero-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
`;
